import CompactHeader from "./CompactHeader";
export default CompactHeader;
